import BibliographyRealInfoMagazine from './BibliographyRealInfoMagazine.vue'

export { BibliographyRealInfoMagazine }
